var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-2.2348338291067193e-8,2.2348338291067193e-8,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-7.63568266393122e-8,7.63568266393122e-8,1,-2.5606381126586086e-7,8.754190883308866e-8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.646484375,3.353515625C1.7790923749999998,3.353515625,1.906270375,3.406194725,2.000038375,3.499962625L6.146484375,7.646405625L10.292934375,3.499962625C10.386694375,3.406194925,10.513874375,3.353515863419,10.646484375,3.353515863419C10.922624375,3.353515863419,11.146484375,3.577373625,11.146484375,3.853515625C11.146484375,3.986124625,11.093804375,4.113301625,11.000034375,4.207069625L6.853594375,8.353515625Q6.560694375,8.646405625,6.146484375,8.646405625Q5.732274375,8.646405625,5.439374375,8.353515625L1.293118375,4.207256625C1.199162475,4.113301625,1.146484375,3.986123625,1.146484375,3.853515625C1.146484375,3.577373625,1.370342375,3.353515625,1.646484375,3.353515625Z",
    fillRule: "evenodd",
    fill: "#222222",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "media/arrow_down.faeda283.svg";
export { ForwardRef as ReactComponent };